<template>
<div id="fullDiv">
    <el-container>
        <el-main>
            <el-row :gutter="20" :style="{ overflow: 'auto' }">
                <el-col :span="24">
                    <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="hover" style="height: 480; margin-bottom: 18px; font-weight: 600; min-width: 290px;">
                        <div slot="header">
                            <span class="sphead" :style="{ color: colors.titleColor }">{{ balanceArr.FullName }}</span>
                            <el-button class="button-color" :style="buttonStyle" @mouseover.native="changeHoverColor" @mouseout.native="resetColor" @click="gotolink" style="margin-left:30px">{{$t('pages.moreDeviceInfo.back')}}</el-button>
                            <el-button class="button-color" :style="buttonStyle" @mouseover.native="changeHoverColor" @mouseout.native="resetColor" @click="openClockSync" style="margin-left:15px">{{$t('pages.moreDeviceInfo.clockSync')}}</el-button>
                            <span style="margin-left:15px;font-size:18px;font-weight:600;" :style="{ color: colors.textColor }">{{ syncedTimeText }}</span>
                            <span class="spstate">
                                <el-tag effect="dark" size="medium" :type="balanceArr.Connect == '连接成功' ? 'success' : 'danger'">
                                    {{
                                        balanceArr.Connect
                                        }}
                                </el-tag>
                            </span>
                        </div>
                        <el-row>
                            <el-col :span="balanceArr.isShowMonitor == '1' ? 16 : 24 ">
                                <el-row>
                                    <el-col :span="12">
                                        <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-bottom: 10px;margin-right:10px;">
                                            <div class="grid-con-1">
                                                <div class="user-info-list-odd">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.cumulativeT')}}</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.totalOutput }}</div>
                                                </div>
                                                <div class="user-info-list">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.flowTh')}}</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.insFlow }}</div>
                                                </div>
                                                <div class="user-info-list-odd">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.beltSpeedMs')}}</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.beltSpeed }}</div>
                                                </div>
                                            </div>
                                        </el-card>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-bottom: 10px;margin-right:10px;">
                                            <div class="grid-con-1">
                                                <div class="user-info-list-odd">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.startTime')}}</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.starTime }}</div>
                                                </div>
                                                <div class="user-info-list">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.lastStopTime')}}</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.downTime }}</div>
                                                </div>
                                                <div class="user-info-list-odd">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.todayRunDuration')}}</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.runningTime }}</div>
                                                </div>
                                            </div>
                                        </el-card>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-bottom: 10px;margin-right:10px">
                                            <div class="grid-con-1">
                                                <div :class="[index % 2 == 0 ? 'user-info-list-odd' : 'user-info-list']" :key="newItem.name" v-for="(newItem, index) in balanceArr.Data">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ newItem.name }}(t)</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ newItem.freWeight }}</div>
                                                </div>
                                            </div>
                                        </el-card>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-bottom: 10px;margin-right:10px;">
                                            <div class="grid-con-1">
                                                <div class="user-info-list-odd">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.dayProduction')}}</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.dayProduction }}</div>
                                                </div>
                                                <div class="user-info-list">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.monthProduction')}}</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.monthProduction }}</div>
                                                </div>
                                                <div class="user-info-list-odd">
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.yearProduction')}}</div>
                                                    <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.yearProduction }}</div>
                                                </div>
                                            </div>
                                        </el-card>
                                    </el-col>
                                </el-row>

                                <el-col :span="12" v-show="isDisplayCNB">
                                    <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-bottom: 10px;margin-right:10px;">
                                        <div class="grid-con-1">
                                            <div class="user-info-list-odd">
                                                <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.hourCNB')}}</div>
                                                <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.hourCNB }}</div>
                                            </div>
                                            <div class="user-info-list">
                                                <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.monthCNB')}}</div>
                                                <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.monthCNB }}</div>
                                            </div>
                                        </div>
                                    </el-card>
                                </el-col>
                                <el-col :span="12" v-show="isDisplayCNB">
                                    <el-card class="box-card" :style="{ backgroundColor: colors.homePageBackgroundColor }" shadow="never" style="margin-bottom: 10px;margin-right:10px;">
                                        <div class="grid-con-1">
                                            <div class="user-info-list-odd">
                                                <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.dayCNB')}}</div>
                                                <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.dayCNB }}</div>
                                            </div>
                                            <div class="user-info-list">
                                                <div :class="[balanceArr.Connect == '连接成功' ? 'titleleftYes' : 'titleleftNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{$t('pages.moreDeviceInfo.yearCNB')}}</div>
                                                <div :class="[balanceArr.Connect == '连接成功' ? 'contentrightYes' : 'contentrightNo']" :style="{ color: balanceArr.Connect === '连接成功' ? colors.textColor : '' }">{{ balanceArr.yearCNB }}</div>
                                            </div>
                                        </div>
                                    </el-card>
                                </el-col>
                                <el-card class="box-card" shadow="never" style="margin-right:10px;" v-show="isDisplayDevice">
                                    <div class="tagClass">
                                        <el-tag v-for="item in balanceArr.epiState" :key="item.label" :type="item.type" effect="dark" style="margin-right:15px;margin-bottom:10px;">
                                            <div v-text="item.label"></div>
                                        </el-tag>
                                    </div>
                                </el-card>
                            </el-col>
                            <el-col :span="8">
                                <video-player v-if="balanceArr.isShowMonitor == '1' ? true : false " :key="playerOptions.sources[0].src" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-col>
                <el-col :span="8" v-if="!ishasData">
                    <el-row>
                        <el-col :span="14">
                            <el-card shadow="hover" style="height: 300px; margin: 10px">
                                <img src="../../assets/img/searchempty.jpg" class="image" style="height: 240px; border-radius: 50%" />

                                <div class="user-info-list">
                                    <span style="margin-left: 35%">{{$t('pages.moreDeviceInfo.empty')}}</span>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" style="margin-top: -30px;">
                <el-tab-pane :label="$t('pages.moreDeviceInfo.hourBar')" name="first" :lazy='true'>
                    <div id="mychart" :style="myChartStyle"></div>
                </el-tab-pane>
                <el-tab-pane :label="$t('pages.moreDeviceInfo.dayBar')" name="second" :lazy='true'>
                    <div id="mydaychart" :style="myChartStyle"></div>
                </el-tab-pane>
                <el-tab-pane :label="$t('pages.moreDeviceInfo.monthBar')" name="third" :lazy='true'>
                    <div id="mymonthchart" :style="myChartStyle"></div>
                </el-tab-pane>
                <el-tab-pane :label="$t('pages.moreDeviceInfo.yearBar')" name="fourth" :lazy='true'>
                    <div id="myyearchart" :style="myChartStyle"></div>
                </el-tab-pane>
                <el-tab-pane label="设备示意图" name="diagram" :lazy='true'>
                    <div class="belt-diagram-panel">
                        <div class="belt-diagram-image-wrap">
                            <div class="belt-diagram-canvas">
                                <img :src="beltDiagramSrc" alt="输送皮带示意图" class="belt-diagram-image">
                                <div class="belt-diagram-conn" :class="diagramConnClass">
                                    <span class="belt-diagram-conn-dot"></span>
                                    <span class="belt-diagram-conn-text">{{ diagramConnText }}</span>
                                </div>
                                <div class="belt-diagram-camera" :class="diagramCameraClass" v-if="cameraStatus && cameraStatus.cameraCount > 0">
                                    <span class="belt-diagram-conn-dot"></span>
                                    <span class="belt-diagram-conn-text">{{ diagramCameraText }}</span>
                                </div>
                                <div class="belt-diagram-screen" :class="diagramMeterClass">
                                    <div class="belt-diagram-screen-row">
                                        <span class="belt-diagram-screen-value">{{ diagramTotalOutput }}</span>
                                        <span class="belt-diagram-screen-unit">t</span>
                                    </div>
                                    <div class="belt-diagram-screen-row">
                                        <span class="belt-diagram-screen-value">{{ diagramInsFlow }}</span>
                                        <span class="belt-diagram-screen-unit">t/h</span>
                                    </div>
                                    <div class="belt-diagram-screen-row">
                                        <span class="belt-diagram-screen-value">{{ diagramBeltSpeed }}</span>
                                        <span class="belt-diagram-screen-unit">m/s</span>
                                    </div>
                                </div>
                            </div>
                        </div>                      
                    </div>
                </el-tab-pane>
                <!-- <el-tab-pane label="实时流量图" name="fifth" :lazy='true'>
                    <div id="device-info-echarts" :style="myChartStyle" v-show="this.isFlowCurve"></div>
                </el-tab-pane> -->
            </el-tabs>
            <el-dialog :title="$t('pages.moreDeviceInfo.clockSync')" :visible.sync="clockSyncVisible" width="520px">
                <el-form label-width="120px">
                    <el-form-item :label="$t('pages.moreDeviceInfo.clientTime')">
                        <span>{{ clientTimeText }}</span>
                    </el-form-item>
                    <el-form-item :label="$t('pages.moreDeviceInfo.syncedTime')">
                        <span>{{ syncedTimeText }}</span>
                    </el-form-item>
                    <el-form-item :label="$t('pages.moreDeviceInfo.offsetSec')">
                        <el-input-number v-model="manualOffsetSec" :min="-86400" :max="86400" :step="1" controls-position="right" style="width: 220px;"></el-input-number>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="clearTimeOffset">{{$t('common.reset')}}</el-button>
                    <el-button type="primary" @click="applyManualOffset">{{$t('common.save')}}</el-button>
                </span>
            </el-dialog>
        </el-main>
    </el-container>
</div>
</template>

<script>
import 'videojs-contrib-hls';
import noVideo from '../../assets/img/noVideo.png';
import yesVideo from '../../assets/img/yesVideo.png';
import beltDiagramPng from '../../assets/img/belt-diagram.png';
import * as echarts from "echarts";
import {
    color
} from 'echarts/lib/theme/dark';

export default {
    data() {
        return {
            colors: {
                menuBarBackgroundColor: '#999',
                homePageBackgroundColor: '#999',
                titleColor: '#999',
                textColor: '#999',
                buttonColor: '#999',
                buttonColor2: '#999',
            },
            buttonStyle: {
                color: '#ffffff',
                fontSize: '20px',
                fontWeight: 'bold',
                fontFamily: '微软雅黑',
                backgroundColor: 'rgb(50, 65, 87)',
                borderColor: '#ffffff',
                borderWidth: '3px',
                marginTop: '-20px'
            },
            param: {
                username: '',
                password: ''
            },
            isFlowCurve: true,
            isColumnChart: true,
            isDisplayCNB: true,
            isDisplayDevice: true,
            deviceName: '',
            deviceId: '',
            videoUrl: '',
            isshow: false,
            screenheight: '',
            picsrc: '../../assets/img/searchempty.jpg',
            name: localStorage.getItem('ms_username'),
            videoArr: [],
            structArr: [],
            balanceArr: [],
            columnNum: 24,
            ishasData: true,
            timer: 0,
            clockTimer: 0,
            clockNow: Date.now(),
            cameraStatus: {
                online: false,
                cameraCount: 0,
                cameras: []
            },
            clockSyncVisible: false,
            timeOffsetMs: parseInt(localStorage.getItem('pdc_time_offset_ms'), 10) || 0,
            manualOffsetSec: 0,
            activeName: 'first',
            flow: 0,
            xData: [], //横坐标
            yData: [], //数据
            xDataDay: [], //横坐标
            yDataDay: [], //数据
            yDataMonth: [],
            xDataMonth: [],
            xDataYear: [],
            yDataYear: [],
            beltDiagramSrc: beltDiagramPng,
            myChart: null,
            mydaychart: null,
            mymonthchart: null,
            myyearchart: null,
            myChartStyle: {
                float: "left",
                width: "100%",
                height: "400px",
                borderType: 'dashed',
            }, //图表样式
            playerOptions: {
                live: true,
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                autoplay: true, // 如果为true,浏览器准备好时开始回放
                language: 'zh-CN',
                aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    src: this.videoUrl // url地址
                }],
                poster: '', // 封面地址
                notSupportedMessage: this.$t('pages.moreDeviceInfo.videoNotSupported'),
                controlBar: {
                    timeDivider: false, // 当前时间和持续时间的分隔符
                    durationDisplay: false, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能
                    fullscreenToggle: true // 是否显示全屏按钮
                }
            }
        }
    },
    created() {
        this.getSystemInfo();
        this.getstructArr();
        this.getCameraStatus();
        // this.$nextTick(() => {
        //     this.initEchartsHandle();
        // });
    },
    watch: {
        '$route.query.videoUrl': {
            handler(newVal) {
                if (newVal && this.playerOptions.sources[0].src !== newVal) {
                    this.$set(this.playerOptions.sources, 0, {
                        src: newVal,
                        type: newVal.indexOf('.m3u8') > -1 ? 'application/x-mpegURL' : 'video/mp4'
                    });
                    this.playerOptions.poster = newVal.indexOf('.m3u8') > -1 ? yesVideo : noVideo;
                }
            },
            immediate: true
        }
    },
    computed: {
        clientTimeText() {
            return this.formatDate(new Date(this.clockNow));
        },
        syncedTimeText() {
            return this.formatDate(new Date(this.clockNow + this.timeOffsetMs));
        },
        isDeviceConnected() {
            const v = this.balanceArr && this.balanceArr.Connect;
            if (v === true) {
                return true;
            }
            if (v === false) {
                return false;
            }
            const s = (v === null || v === undefined) ? '' : String(v);
            return s === '连接成功' || s.toLowerCase() === 'connected' || s.toLowerCase() === 'success';
        },
        diagramConnText() {
            return this.isDeviceConnected ? this.$t('pages.moreDeviceInfo.diagramConnOk') : this.$t('pages.moreDeviceInfo.diagramConnBad');
        },
        diagramConnClass() {
            return this.isDeviceConnected ? 'is-ok' : 'is-alarm alarm-blink';
        },
        diagramMeterClass() {
            return this.isDeviceConnected ? 'is-ok' : 'is-alarm alarm-blink';
        },
        diagramTotalOutput() {
            return this.isDeviceConnected && this.balanceArr && this.balanceArr.totalOutput !== undefined ? this.balanceArr.totalOutput : '--';
        },
        diagramInsFlow() {
            return this.isDeviceConnected && this.balanceArr && this.balanceArr.insFlow !== undefined ? this.balanceArr.insFlow : '--';
        },
        diagramBeltSpeed() {
            return this.isDeviceConnected && this.balanceArr && this.balanceArr.beltSpeed !== undefined ? this.balanceArr.beltSpeed : '--';
        },
        diagramCameraText() {
            if (!this.cameraStatus || this.cameraStatus.cameraCount === 0) return '';
            return this.cameraStatus.online ? this.$t('pages.moreDeviceInfo.diagramCameraOk') : this.$t('pages.moreDeviceInfo.diagramCameraBad');
        },
        diagramCameraClass() {
            if (!this.cameraStatus || this.cameraStatus.cameraCount === 0) return '';
            return this.cameraStatus.online ? 'is-ok' : 'is-alarm alarm-blink';
        }
    },
    mounted: function () {
        if (this.clockTimer) {
            clearInterval(this.clockTimer);
        }
        this.clockTimer = setInterval(() => {
            this.clockNow = Date.now();
        }, 1000);

        if (this.timer) {
            clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
            this.getstructArr();
            this.getCameraStatus();
        }, 1000 * 2)
    },
    destroyed() {
        clearInterval(this.timer);
        clearInterval(this.clockTimer);
    },
    methods: {
        gotolink() {
            //指定跳转地址
            this.$router.back();
        },
        initEcharts() {
            // 基本柱状图
            const option = {
                backgroundColor: this.colors.homePageBackgroundColor,
                textStyle: {
                    color: this.colors.textColor,
                },
                title: [{
                    text: this.$t('pages.moreDeviceInfo.hourBar'),
                    textStyle: {
                        color: this.colors.textColor
                    }
                }],
                tooltip: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    name: this.$t('pages.moreDeviceInfo.axisHour'),
                    data: this.xData,
                    axisLabel: {
                        fontSize: 15
                    },
                    axisTick: {
                        alignWithLabel: true
                    }
                }],
                yAxis: [{
                    type: 'value',
                    name: this.$t('pages.moreDeviceInfo.axisProdT'),
                }],
                series: [{
                    name: '时产量',
                    type: "bar", //形状为柱状图
                    barWidth: 'auto',
                    data: this.yData,
                    itemStyle: {
                        color: this.colors.textColor,
                        float: "left",
                        width: "100%",
                        height: "400px",
                        borderType: 'dashed',
                    }, //图表样式
                }]
            };
            this.myChart = echarts.init(document.getElementById("mychart"));
            this.myChart.setOption(option);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                this.myChart.resize();
            })
        },
        initDayEcharts() {
            // 基本柱状图
            const optionday = {
                backgroundColor: this.colors.homePageBackgroundColor,
                textStyle: {
                    color: this.colors.textColor,
                },
                title: [{
                    text: this.$t('pages.moreDeviceInfo.dayBar'),
                    textStyle: {
                        color: this.colors.textColor
                    }
                }],
                tooltip: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    name: this.$t('pages.moreDeviceInfo.axisDay'),
                    data: this.xDataDay,
                    axisLabel: {
                        fontSize: 15
                    },
                    axisTick: {
                        alignWithLabel: true
                    }
                }],
                yAxis: [{
                    type: 'value',
                    name: this.$t('pages.moreDeviceInfo.axisProdT'),
                }],
                series: [{
                    name: '日产量',
                    type: "bar", //形状为柱状图
                    barWidth: 'auto',
                    data: this.yDataDay,
                    itemStyle: {
                        color: this.colors.textColor,
                        float: "left",
                        width: "100%",
                        height: "400px",
                        borderType: 'dashed',
                    }, //图表样式
                }]
            };
            this.mydaychart = echarts.init(document.getElementById("mydaychart"));
            this.mydaychart.setOption(optionday);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                this.mydaychart.resize();
            })
        },
        initMonthEcharts() {
            // 基本柱状图
            const optionmonth = {
                backgroundColor: this.colors.homePageBackgroundColor,
                textStyle: {
                    color: this.colors.textColor,
                },
                title: [{
                    text: this.$t('pages.moreDeviceInfo.monthBar'),
                    textStyle: {
                        color: this.colors.textColor
                    }
                }],
                tooltip: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    name: this.$t('pages.moreDeviceInfo.axisMonth'),
                    data: this.xDataMonth,
                    axisLabel: {
                        fontSize: 15
                    },
                    axisTick: {
                        alignWithLabel: true
                    }
                }],
                yAxis: [{
                    type: 'value',
                    name: this.$t('pages.moreDeviceInfo.axisProdT'),
                }],
                series: [{
                    name: '月产量',
                    type: "bar", //形状为柱状图
                    barWidth: 'auto',
                    data: this.yDataMonth,
                    itemStyle: {
                        color: this.colors.textColor,
                        float: "left",
                        width: "100%",
                        height: "400px",
                        borderType: 'dashed',
                    }, //图表样式
                }]
            };
            this.mymonthchart = echarts.init(document.getElementById("mymonthchart"));
            this.mymonthchart.setOption(optionmonth);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                this.mymonthchart.resize();
            })
        },
        initYearEcharts() {
            const optionyear = {
                backgroundColor: this.colors.homePageBackgroundColor,
                textStyle: {
                    color: this.colors.textColor,
                },
                title: [{
                    text: this.$t('pages.moreDeviceInfo.yearBar'),
                    textStyle: {
                        color: this.colors.textColor
                    }
                }],
                tooltip: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: [{
                    type: 'category',
                    name: this.$t('pages.moreDeviceInfo.axisYear'),
                    data: this.xDataYear,
                    axisLabel: {
                        fontSize: 15
                    },
                    axisTick: {
                        alignWithLabel: true
                    }
                }],
                yAxis: [{
                    type: 'value',
                    name: this.$t('pages.moreDeviceInfo.axisProdT'),
                }],
                series: [{
                    name: '年产量',
                    type: "bar",
                    barWidth: 'auto',
                    data: this.yDataYear,
                    itemStyle: {
                        color: this.colors.textColor,
                        float: "left",
                        width: "100%",
                        height: "400px",
                        borderType: 'dashed',
                    },
                }]
            };
            this.myyearchart = echarts.init(document.getElementById("myyearchart"));
            this.myyearchart.setOption(optionyear);
            window.addEventListener("resize", () => {
                this.myyearchart.resize();
            })
        },
        initEchartsHandle() {
            // 基础配置代码
            var optionHandle = {
                textStyle: {
                    color: this.colors.textColor,
                },
                title: {
                    text: this.$t('pages.moreDeviceInfo.realtimeFlow'),
                    textStyle: {
                        color: this.colors.textColor
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#6a7985",
                        },
                    },
                },
                legend: {
                    data: [this.$t('pages.moreDeviceInfo.axisFlow')],
                    textStyle: {
                        color: this.colors.textColor
                    }
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: [{
                    type: "category",
                    name: this.$t('pages.moreDeviceInfo.axisTime'),
                    boundaryGap: false,
                    data: [""],
                }, ],
                yAxis: [{
                    type: "value",
                    name: this.$t('pages.moreDeviceInfo.axisFlow'),
                }, ],
                series: [{
                    name: this.$t('pages.moreDeviceInfo.axisFlow'),
                    type: "line",
                    stack: "Total",
                    areaStyle: {},
                    emphasis: {
                        focus: "series",
                    },
                    smooth: true,
                    data: [1],
                    areaStyle: {
                        color: "#FFFFFF",
                        origin: "auto"
                    },
                    lineStyle: {
                        width: 2,
                        type: "solid",
                    },
                }],
            };
            const lineChart = echarts.init(document.getElementById("device-info-echarts"));
            lineChart.setOption(optionHandle);
            // 页面尺寸发生变化时，echarts布局自适应
            window.addEventListener("resize", function () {
                lineChart.resize();
            });

            this.getLatestData(lineChart, optionHandle);
            // // 模拟推送数据————（可根据实际数据获取方式调整）
            // setInterval(() => {
            //     this.getLatestData(lineChart, optionHandle);
            // }, 2000); // 实时 两秒 获取数据
        },
        // 获取数据
        getLatestData(lineChart, optionHandle) {
            // 添加最新数据项
            this.randomChange();
            optionHandle.series.forEach((item, index) => {
                item.data.push(this.flow);
                //截取最新的固定条数的数据(截取10个)
                item.data = item.data.slice(-10);
            });
            // 如果X轴也是实时数据，可以这样更新
            var NowTime = this.formatDate(new Date(this.clockNow + this.timeOffsetMs), true);
            //添加数据并截取最后十位最新数据
            optionHandle.xAxis[0].data.push(NowTime);
            optionHandle.xAxis[0].data = optionHandle.xAxis[0].data.slice(-10);

            optionHandle.backgroundColor = this.colors.homePageBackgroundColor;
            optionHandle.series[0].lineStyle.color = this.colors.textColor;
            optionHandle.series[0].areaStyle.color = this.colors.textColor;
            optionHandle.title.textStyle.color = this.colors.textColor;
            optionHandle.legend.textStyle.color = this.colors.textColor;
            optionHandle.textStyle.color = this.colors.textColor;

            //重新配置数据
            lineChart.setOption(optionHandle, true);
        },
        //时间格式化
        formatDate(date, isEchart = undefined) {
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            const hour = date.getHours();
            const minute = date.getMinutes();
            const second = date.getSeconds();
            const formatNumber = (n) => {
                n = n.toString();
                return n[1] ? n : "0" + n;
            };
            if (isEchart) {
                return [hour, minute, second].map(formatNumber).join(":");
            } else {
                return (
                    [year, month, day].map(formatNumber).join("-") +
                    " " + [hour, minute, second].map(formatNumber).join(":")
                );
            }
        },
        randomChange() {
            const randomSign = Math.random() < 0.5 ? 1 : -1; // 随机生成正负号
            this.flow = (this.flow * (1 + 0.1 * randomSign)).toFixed(2); // 当前值随机增加或减少10%
        },
        openClockSync() {
            this.clockSyncVisible = true;
            this.manualOffsetSec = Math.round(this.timeOffsetMs / 1000);
        },
        setTimeOffset(ms) {
            this.timeOffsetMs = ms;
            localStorage.setItem('pdc_time_offset_ms', String(ms));
            this.$message.success(this.$t('pages.moreDeviceInfo.clockSyncSaved'));
        },
        applyManualOffset() {
            const sec = parseFloat(this.manualOffsetSec) || 0;
            this.setTimeOffset(Math.round(sec * 1000));
        },
        clearTimeOffset() {
            this.manualOffsetSec = 0;
            this.setTimeOffset(0);
        },
        getCameraStatus() {
            if (!this.deviceId) return;
            this.$zybhttp.get('MonitorEqu/CameraStatus?balanceId=' + this.deviceId)
                .then(res => {
                    let responseData = res.data || res;
                    if (responseData.status == 0 || responseData.code == 200 || responseData.status == 200) {
                        let data = responseData.data || responseData;
                        if (data) {
                            this.cameraStatus = {
                                online: data.online,
                                cameraCount: data.cameraCount || 0,
                                cameras: data.cameras || []
                            };
                        }
                    }
                })
                .catch(err => console.error('获取摄像头状态异常:', err));
        },
        handleClick(tab, event) {
            if (this.activeName == 'first') {
                            this.$nextTick(() => {
                                this.initEcharts();
                                this.myChart.resize();
                            });
                        } else if (this.activeName == 'second') {
                            this.$nextTick(() => {
                                this.initDayEcharts();
                                this.mydaychart.resize();
                            });
                        } else if (this.activeName == 'third') {
                            this.$nextTick(() => {
                                this.initMonthEcharts();
                                this.mymonthchart.resize();
                            });
                        } else if (this.activeName == 'fourth') {
                            this.$nextTick(() => {
                                this.initYearEcharts();
                                this.myyearchart.resize();
                            });
                        }
        },
        getData() {
            this.ishasData = true;
        },
        getSystemInfo() {
            this.$zybhttp
                .get('Business/GetSystemInfo', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data;
                        this.isDisplayCNB = d.data.list[0].isCNB == 1 ? true : false;
                        this.isDisplayDevice = d.data.list[0].isDisplayDeviceStatus == 1 ? true : false;
                        this.isFlowCurve = d.data.list[0].isFlowCurve == true ? true : false;
                        this.isColumnChart = d.data.list[0].isColumnChart == true ? true : false;
                        this.colors.menuBarBackgroundColor = d.data.list[0].menuBarBackgroundColor;
                        this.colors.homePageBackgroundColor = d.data.list[0].homePageBackgroundColor;
                        this.colors.titleColor = d.data.list[0].titleColor;
                        this.colors.textColor = d.data.list[0].textColor;
                        this.colors.buttonColor = d.data.list[0].buttonColor;
                        this.colors.buttonColor2 = d.data.list[0].buttonColor2;
                        this.buttonStyle.color = this.colors.textColor; // 修改文字颜色为红色
                        this.buttonStyle.backgroundColor = this.colors.buttonColor; // 修改背景色为蓝色
                        this.buttonStyle.borderColor = this.colors.textColor; // 修改边框颜色为绿色
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getstructArr() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            let devId = this.$route.query.id.toString();
            this.$zybhttp
                .post('Business/GetDevData', {
                    Field1: userInfo.userType,
                    Field2: userInfo.realName,
                    Field3: userInfo.loginId,
                    Field4: devId
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var data = res.data.data.list;
                        this.deviceId = this.$route.query.id;
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].BalanceId == this.deviceId) {
                                data = data[i];
                                this.flow = parseFloat(data.insFlow).toFixed(2);
                                data.insFlow = parseFloat(data.insFlow).toFixed(2);
                                data.beltSpeed = parseFloat(data.beltSpeed).toFixed(2);
                                this.yData = [];
                                this.xData = [];
                                this.xDataDay = [];
                                this.yDataDay = [];
                                this.yDataMonth = [];
                                this.xDataMonth = [];
                                this.xDataYear = [];
                                this.yDataYear = [];
                                for (let i = 0; i < data.hourData.length; i++) {
                                    this.yData.push(data.hourData[i].weight);
                                    this.xData.push(data.hourData[i].date)
                                }
                                for (let i = 0; i < data.dayData.length; i++) {
                                    this.yDataDay.push(data.dayData[i].weight);
                                    this.xDataDay.push(data.dayData[i].date)
                                }
                                for (let i = 0; i < data.monthData.length; i++) {
                                    this.yDataMonth.push(data.monthData[i].weight);
                                    this.xDataMonth.push(data.monthData[i].date)
                                }
                                const yearNow = new Date().getFullYear();
                                const seed = parseInt(this.deviceId, 10) || 1;
                                const rand = (i) => {
                                    const n = (seed * 9301 + 49297 * (i + 1)) % 233280;
                                    return n / 233280;
                                };
                                const monthSum = Array.isArray(data.monthData) ?
                                    data.monthData.reduce((sum, item) => sum + (parseFloat(item.weight) || 0), 0) :
                                    0;
                                const baseYear = parseFloat(data.yearProduction);
                                const baseTotal = Number.isFinite(baseYear) ? baseYear : monthSum;
                                const yearCount = 5;
                                for (let i = 0; i < yearCount; i++) {
                                    const y = yearNow - (yearCount - 1) + i;
                                    const trend = 0.75 + (0.25 * i) / (yearCount - 1);
                                    const noise = 0.9 + 0.2 * rand(i);
                                    const val = (baseTotal * trend * noise).toFixed(2);
                                    this.xDataYear.push(String(y));
                                    this.yDataYear.push(parseFloat(val));
                                }
                                this.balanceArr = data;
                            }
                        }
                        if (this.activeName == 'first') {
                            this.$nextTick(() => {
                                this.initEcharts();
                            });
                        } else if (this.activeName == 'second') {
                            this.$nextTick(() => {
                                this.initDayEcharts();
                            });
                        } else if (this.activeName == 'third') {
                            this.$nextTick(() => {
                                this.initMonthEcharts();
                            });
                        } else if (this.activeName == 'fourth') {
                            this.$nextTick(() => {
                                this.initYearEcharts();
                            });
                        }
                        // else if (this.activeName == 'fifth') {
                        //     this.$nextTick(() => {
                        //         this.initEchartsHandle();
                        //     });
                        // }

                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        changeHoverColor() {
            this.buttonStyle.backgroundColor = this.colors.buttonColor2;
        },
        resetColor() {
            this.buttonStyle.backgroundColor = this.colors.buttonColor;
        },
    }
};
</script>

<style scoped>
.button-color {
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
    font-family: 微软雅黑;
    background-color: rgb(50, 65, 87);
    border-color: rgb(255, 255, 255);
    border-width: 3px;
}

.button-color:hover {
    background-color: rgb(87, 106, 134);
}

.box-card {
    background-color: rgb(50, 65, 87);
}

.login-btn {
    text-align: center;
}

.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}

.el-row {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.belt-diagram-panel {
    display: flex;
    align-items: stretch;
    gap: 16px;
    min-height: 400px;
}

.belt-diagram-image-wrap {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: #ffffff;
    border-radius: 8px;
}

.belt-diagram-canvas {
    position: relative;
    width: 100%;
    max-height: 400px;
}

.belt-diagram-image {
    display: block;
    width: 100%;
    max-height: 400px;
    object-fit: contain;
}

.belt-diagram-conn {
    position: absolute;
    left: 14px;
    top: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.65);
    border: 2px solid transparent;
    font-weight: 700;
    user-select: none;
}

.belt-diagram-camera {
    position: absolute;
    right: 14px;
    top: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.65);
    border: 2px solid transparent;
    font-weight: 700;
    user-select: none;
}

.belt-diagram-camera.is-ok {
    color: #67c23a;
    border-color: #67c23a;
}

.belt-diagram-camera.is-alarm {
    color: #f56c6c;
    border-color: #f56c6c;
}

.belt-diagram-conn-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: currentColor;
}

.belt-diagram-conn.is-ok {
    color: #67c23a;
    border-color: #67c23a;
}

.belt-diagram-conn.is-alarm {
    color: #f56c6c;
    border-color: #f56c6c;
}

.belt-diagram-screen {
    position: absolute;
    left: 59.5%;
    top: 51%;
    width: 172px;
    padding: 10px 10px 8px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.08);
    border: 2px solid transparent;
    box-sizing: border-box;
    user-select: none;
}

.belt-diagram-screen.is-ok {
    color: #67c23a;
    border-color: #67c23a;
}

.belt-diagram-screen.is-alarm {
    color: #f56c6c;
    border-color: #f56c6c;
}

.belt-diagram-screen-row {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    gap: 8px;
    margin-bottom: 6px;
    font-weight: 800;
}

.belt-diagram-screen-row:last-child {
    margin-bottom: 0;
}

.belt-diagram-screen-value {
    font-size: 18px;
    letter-spacing: 0.2px;
}

.belt-diagram-screen-unit {
    font-size: 12px;
    opacity: 0.9;
    font-weight: 700;
}

.alarm-blink {
    animation: alarmBlink 1.2s infinite;
}

@keyframes alarmBlink {
    0% { opacity: 1; }
    50% { opacity: 0.35; }
    100% { opacity: 1; }
}

.belt-diagram-data-card {
    width: 280px;
    flex-shrink: 0;
    padding: 20px;
    border: 1px solid;
    border-radius: 8px;
    box-sizing: border-box;
}

.belt-diagram-title {
    font-size: 22px;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 24px;
    word-break: break-all;
}

.belt-diagram-data-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    line-height: 1.6;
    margin-bottom: 14px;
}

.belt-diagram-label {
    color: #909399;
}

.belt-diagram-value {
    margin-left: 12px;
    font-weight: bold;
    color: inherit;
}

.belt-diagram-tip {
    margin-top: 28px;
    font-size: 14px;
    color: #909399;
}

.user-info-list {
    font-size: 27px;
    color: #999;
    line-height: 30px;
    display: -webkit-flex;
}

.user-info-list-odd {
    font-size: 27px;
    color: #999;
    line-height: 30px;
    display: -webkit-flex;
}

.titleleftNo {
    width: 40%;
    padding-left: 0.5rem;
    color: crimson;
    font-weight: bold;
    font-family: 微软雅黑;
}

.titleleftYes {
    width: 40%;
    padding-left: 0.5rem;
    color: #ffffff;
    font-weight: bold;
    font-family: 微软雅黑;
}

.contentleft {
    width: 60%;
    color: crimson;
    font-family: 微软雅黑;
}

.el-card__header {
    background-color: cornsilk;
}

.sphead {
    font-size: 27px;
    color: rgb(232, 244, 255);
    font-family: cursive;
}

.nologin {
    float: right;
    font-size: 14px;
    color: red;
    margin-right: 10px;
    margin-top: 5px;
}

.spstate {
    float: right;
}

.contentrightNo {
    width: 60%;
    color: crimson;
    font-weight: bold;
    font-family: 微软雅黑;
}

.contentrightYes {
    width: 60%;
    font-weight: bold;
    color: #ffffff;
    font-family: 微软雅黑;
}
</style><style>
.el-card__body {
    padding: 10px 20px;
    font-weight: 500;
}

element.style {
    background: #e0dcda;
}

.el-card__header {
    padding: 10px 20px;
}

.tagClass .el-tag {
    font-size: 24px;
}

.tagClass .el-tag--small {
    height: 32px;
    padding: 0 10px;
    line-height: 32px;
}
</style>
